import { Link } from 'react-router-dom';

const stats = [
  { value: '1200+', label: '收录影片', icon: 'ri-film-line', tone: 'primary' },
  { value: '8', label: '影片类型', icon: 'ri-price-tag-3-line', tone: 'accent' },
  { value: '4K', label: '清晰度演示', icon: 'ri-hd-line', tone: 'secondary' },
  { value: '24/7', label: '随时可看', icon: 'ri-time-line', tone: 'primary' },
];

const features = [
  {
    icon: 'ri-play-circle-line',
    title: '快速进入播放',
    desc: '首页焦点直达，一键跳转影片详情与演示播放区，无需多余步骤。',
  },
  {
    icon: 'ri-stack-line',
    title: '分类与筛选',
    desc: '按类型多选筛选、按热度或评分排序，快速找到合口味的剧情片。',
  },
  {
    icon: 'ri-book-open-line',
    title: '剧情与剧照',
    desc: '每部影片配有剧情简介与精选剧照，先了解故事再决定要不要看。',
  },
  {
    icon: 'ri-heart-line',
    title: '本地收藏',
    desc: '一键收藏想看的影片，收藏记录保存在本机浏览器，随时找回。',
  },
];

const toneClass: Record<string, string> = {
  primary: 'bg-primary-500/12 text-primary-400',
  accent: 'bg-accent-500/12 text-accent-400',
  secondary: 'bg-secondary-500/12 text-secondary-300',
};

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-900">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div>
          <span className="text-xs font-display tracking-[0.3em] text-secondary-300">ABOUT THE SITE</span>
          <h2 className="mt-3 text-2xl md:text-4xl font-heading font-black text-foreground-50 leading-tight">
            一个专注剧情片的
            <br />
            在线观影门户
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-300 leading-relaxed">
            善良的小姨子影视站以电影《善良的小姨子》为核心，聚合剧情、家庭、悬疑、爱情等类型的优质影片。
            我们相信好故事值得被认真对待，因此为每部影片准备了完整剧情简介、主创信息与精选剧照，帮助你更快找到想看的电影。
          </p>
          <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
            本站为内容展示演示站点，播放区域为前端效果演示，不提供真实视频流与下载，所有影片资料仅用于界面与交互演示。
          </p>
          <div className="mt-7 flex items-center gap-3">
            <Link
              to="/movie-detail/1"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill"></i>
              观看《善良的小姨子》
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-800/70 border border-background-700 text-foreground-100 text-sm font-medium hover:bg-background-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {stats.map((stat) => (
              <div key={stat.label}>
                <span className={`w-9 h-9 rounded-md flex items-center justify-center ${toneClass[stat.tone]}`}>
                  <i className={`${stat.icon} text-lg`}></i>
                </span>
                <p className="mt-3 text-xl md:text-2xl font-display tracking-wide text-foreground-50">{stat.value}</p>
                <p className="text-xs text-foreground-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-5 md:p-6 rounded-lg bg-background-800/50 border border-background-700/70 hover:border-primary-500/50 transition-colors"
            >
              <span className="w-11 h-11 rounded-md bg-primary-500/12 text-primary-400 flex items-center justify-center">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-50">{feature.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-400 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}